// extracted by mini-css-extract-plugin
export var labelWrapper = "_dk-0";